// Production steps of ECMA-262, Edition 5, 15.4.4.17
// Reference: http://es5.github.io/#x15.4.4.17
function ArraySomePolyfill(fun, thisArg) {
  'use strict';

  if (this == null) {
    throw new TypeError('Array.prototype.some called on null or undefined');
  }

  if (typeof fun !== 'function') {
    throw new TypeError();
  }

  var t = Object(this);
  var len = t.length >>> 0;

  for (var i = 0; i < len; i++) {
    if (i in t && fun.call(thisArg, t[i], i, t)) {
      return true;
    }
  }
  return false;
};

module.exports = Array.prototype.some || ArraySomePolyfill;



//////////////////
// WEBPACK FOOTER
// ./polyfills/array-some.js
// module id = 706
// module chunks = 0